(function () {
  'use strict';
  if (window.__nepheGoalieFullRight) return;
  window.__nepheGoalieFullRight = true;

  var path = location.pathname.toLowerCase();
  if (path.indexOf('gardien') === -1 && path.indexOf('goalie') === -1) return;

  var TEXTS = {
    fr: {
      stock: '⏱ Fabrication sur commande. Cette canne est produite à la demande, livraison sous 6 à 9 semaines.',
      title: '⏱ Fabriquée sur commande, 6 à 9 semaines',
      text: "La canne de gardien Full Right n'est pas tenue en stock : elle est fabriquée spécialement pour toi, comme une NEPHE+. Délai de livraison de 6 à 9 semaines après commande. N'hésite pas à nous contacter si besoin, et belle saison à toi !"
    },
    en: {
      stock: '⏱ Made to order. This stick is produced on demand, delivery in 6 to 9 weeks.',
      title: '⏱ Made to order, 6 to 9 weeks',
      text: 'The Full Right goalie stick is not kept in stock: it is made especially for you, like a NEPHE+. Delivery takes 6 to 9 weeks after ordering. Feel free to reach out if you need anything, and have a great season!'
    },
    de: {
      stock: '⏱ Auf Bestellung gefertigt. Dieser Stock wird auf Anfrage produziert, Lieferung in 6 bis 9 Wochen.',
      title: '⏱ Auf Bestellung gefertigt, 6 bis 9 Wochen',
      text: 'Der Goalie-Stock Full Right ist nicht auf Lager: Er wird speziell für dich gefertigt, wie ein NEPHE+. Die Lieferzeit beträgt 6 bis 9 Wochen nach der Bestellung. Melde dich gerne bei uns, falls du Fragen hast, und einen schönen Saisonstart!'
    }
  };
  var lang = (document.documentElement.getAttribute('lang') || 'fr').slice(0, 2).toLowerCase();
  var t = TEXTS[lang] || TEXTS.fr;
  var original = null;

  function isFullRight() {
    var radios = document.querySelectorAll('input[type="radio"]:checked');
    for (var i = 0; i < radios.length; i++) {
      if (/full\s*right/i.test(radios[i].value || '')) return true;
    }
    var options = document.querySelectorAll('select option:checked');
    for (var j = 0; j < options.length; j++) {
      if (/full\s*right/i.test(options[j].value || options[j].textContent || '')) return true;
    }
    return false;
  }

  function apply() {
    var msg = document.querySelector('nephe-stock-message');
    var modal = document.querySelector('.nephe-preorder-modal');
    var title = modal && modal.querySelector('.nephe-preorder-modal__title');
    var text = modal && modal.querySelector('.nephe-preorder-modal__text');
    var span = msg && msg.querySelector('.nephe-stock-msg__text');
    if (!original && title && text) {
      original = { title: title.textContent, text: text.textContent };
    }
    var preorder = msg && msg.classList.contains('nephe-stock-msg--preorder');
    if (isFullRight() && preorder) {
      if (span) span.textContent = t.stock;
      if (title) title.textContent = t.title;
      if (text) text.textContent = t.text;
    } else if (original) {
      if (title) title.textContent = original.title;
      if (text) text.textContent = original.text;
    }
  }

  function schedule() {
    setTimeout(apply, 60);
    setTimeout(apply, 400);
  }

  document.addEventListener('variant:update', schedule);
  document.addEventListener('change', schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
